/* DaniChou Ratgeber v2 (2026-10-13): Lesefortschritt, aktives Inhaltsverzeichnis, Link kopieren */
(function () {
  var root = document.querySelector('[data-dcb-article]');
  if (!root) return;
  var bar = root.querySelector('[data-dcb-progress]');
  var prose = root.querySelector('.dcb-prose');
  var toc = root.querySelector('[data-dcb-toc]');
  if (toc && window.matchMedia('(max-width: 989px)').matches) toc.removeAttribute('open');
  var links = toc ? Array.prototype.slice.call(toc.querySelectorAll('a[href^="#"]')) : [];
  var heads = links.map(function (a) { try { return document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1))); } catch (e) { return null; } });
  var ticking = false;
  function update() {
    ticking = false;
    if (bar && prose) {
      var r = prose.getBoundingClientRect();
      var total = r.height - window.innerHeight * 0.6;
      var done = Math.min(Math.max(-r.top + window.innerHeight * 0.2, 0), Math.max(total, 1));
      bar.style.width = (done / Math.max(total, 1) * 100).toFixed(1) + '%';
    }
    if (links.length) {
      var act = -1;
      for (var i = 0; i < heads.length; i++) { if (heads[i] && heads[i].getBoundingClientRect().top < 140) act = i; }
      links.forEach(function (a, i) { a.classList.toggle('is-active', i === act); });
    }
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }, { passive: true });
  update();
  if (toc) toc.addEventListener('click', function (e) {
    if (e.target.closest('a') && window.matchMedia('(max-width: 989px)').matches) toc.removeAttribute('open');
  });
  root.querySelectorAll('[data-dcb-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var url = b.getAttribute('data-dcb-copy');
      var done = function () { var t = b.textContent; b.textContent = 'Link kopiert'; setTimeout(function () { b.textContent = t; }, 1800); };
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, done); else done();
    });
  });
})();
